<ng-template #headerTpl>
  <div class="m-accordion-header-content">
    <div class="m-accordion-header-left">
      @if (iconTemplate) {
        <span class="m-accordion-header-icon">
          <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        </span>
      }
      <span class="m-accordion-title sh2 text-gray-1000">
        @if (header) {
          {{ header }}
        }
        <ng-content select="[header]"></ng-content>
      </span>
      @if (hasCount()) {
        <span class="m-accordion-count b2 text-gray-800">{{ count }}</span>
      }
      @if (typeLabel) {
        <span class="m-accordion-type-pill c1 text-gray-1000">
          {{ typeLabel }}
        </span>
      }
      @if (alertText) {
        <span class="m-accordion-alert">
          <span class="material-symbols-outlined m-accordion-alert-icon">
            {{ alertIcon }}
          </span>
          <span class="c2 text-gray-800">{{ alertText }}</span>
        </span>
      }
    </div>
    <div class="m-accordion-header-right">
      <ng-content select="[headerRight]"></ng-content>
    </div>
  </div>
</ng-template>

<ng-template #bodyTpl>
  <div class="m-accordion-content-body">
    <ng-content></ng-content>
  </div>
</ng-template>
